
import { library } from '@fortawesome/fontawesome-svg-core'


/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import {
  faUser,
  faSignal,
  faLocationDot,
  faCircleExclamation,
  faRightToBracket,
  faUserPlus,
  faArrowRightToBracket,
  faUserSlash,
  faBan,
  faCommentDots,
  faCrown,
  faPaperPlane,
  faIdBadge,
  faUserClock,
  faPlugCircleXmark,
  faGamepad,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faPlus,
  faXmark,
  faPen,
  faDownload,
  faUpload,
  faChevronRight,
  faLock,
  faShieldHalved,
  faCircleCheck,
  faCircleQuestion,
  faQuestion,
  faCrosshairs,
  faUsers,
  faFlag,
  faRobot,
} from '@fortawesome/free-solid-svg-icons'

library.add(faUser)
library.add(faCircleExclamation)
library.add(faSignal)
library.add(faLocationDot)
library.add(faRightToBracket)
library.add(faUserPlus)
library.add(faArrowRightToBracket)
library.add(faUserSlash)
library.add(faBan)
library.add(faCommentDots)
library.add(faCrown)
library.add(faPaperPlane)
library.add(faIdBadge)
library.add(faUserClock)
library.add(faPlugCircleXmark)
library.add(faGamepad)
library.add(faArrowUp)
library.add(faArrowDown)
library.add(faArrowRight)
library.add(faPlus)
library.add(faXmark)
library.add(faPen)
library.add(faDownload)
library.add(faUpload)
library.add(faChevronRight)
library.add(faLock)
library.add(faShieldHalved)
library.add(faCircleCheck)
library.add(faCircleQuestion)
library.add(faQuestion)
library.add(faCrosshairs)
library.add(faUsers)
library.add(faFlag)
library.add(faRobot)

export { FontAwesomeIcon }
